module.exports = __webpack_public_path__ + "assets/img/logos/markets/windows.png";